<template>
  <div class="testPage_container">
    <van-nav-bar>
      <template #left left-arrow>
        <div @click="onTopic()" style="display:flex;align-items:center;height:100%;padding-left:32px;margin-left:-32px;">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
          <div class="testnum">
            <span
              >{{ examType[currentQuestion.type - 1] }}题 /
              {{ currentQuestion.score }}分</span
            >
          </div>
        </div>
      </template>
      <template #title>
        <span>{{ testtext }}</span>
        <span v-if="justWatch" style="font-weight:400;">
          (<span style="font-size: 22px; color: #202124; padding-right: 5px;">{{
            currentRanking
          }}</span>
          <span style="padding-top: 3px">/ {{ examTotal }}</span
          >)
        </span>
      </template>
      <template #right>
        <div v-if="!justWatch">
          <span style="font-size: 22px; color: #202124; padding-right: 5px">{{
            currentRanking
          }}</span>
          <span style="padding-top: 3px">/ {{ examTotal }}</span>
        </div>
        <van-icon
          v-else
          class="setting-icon"
          name="setting-o"
          @click="showWatchSettingChoose"
        />
      </template>
    </van-nav-bar>
    <!-- 题目内容 -->
    <div
      class="centerContent"
      @touchstart="moveStart"
      @touchmove="onMove"
      @touchend="moveEnd"
    >
      <div class="examContent">
        <h3 class="examContent-topic" v-html="currentQuestion.title">
          {{ currentQuestion.title }}
        </h3>
        <div class="examContent-option">
          <ul>
            <li
              v-for="(item, index) in currentQuestion.options"
              @click="activebtn(item)"
              :class="chooseColor(item)"
              :key="index"
            >
              <span>{{ item.optionNumber }}.</span>
              <p class="optionContent" v-html="item.optionContent">
                {{ item.optionContent }}
              </p>
              <span v-if=" chooseColor(item) === 'activeSpan' && (justWatch || currentQuestion.reply) ">
                  <svg-icon icon-class="right-icon" class-name="right-icon"></svg-icon>
              </span>
              <span v-if=" chooseColor(item) === 'cuoSpan' && (justWatch || currentQuestion.reply) ">
                    <svg-icon icon-class="wrong-icon" class-name="wrong-icon"></svg-icon>
              </span>
            </li>
          </ul>
        </div>
        <van-button
          class="saveMultipleOptionsBtn"
          round
          type="info"
          v-show="
            currentQuestion.type == 2 && !justWatch && !currentQuestion.reply
          "
          @click="saveMultipleOptions"
          >提交答案</van-button
        >
      </div>
      <div class="exam-analysis" v-if="justWatch || currentQuestion.reply">
        <div class="analysis-type">
          <span class="choose">
            正确答案：
            <span class="analyOption">{{ currentQuestion.rightAnswer }}</span>
          </span>
          <span class="choose">
            您的答案：
            <span
              :class="
                currentQuestion.result !== 1 ? 'noanalyOption' : 'analyOption'
              "
            >
              {{ currentQuestion.userAnswer || "未答" }}
            </span>
          </span>
        </div>
        <p class="stjx">试题解析</p>
        <p
          v-html="currentQuestion.remark"
          class="analysis-content optionContent"
          v-if="currentQuestion.remark"
        ></p>
        <p v-else class="analysis-content optionContent">无</p>
      </div>
    </div>
    <div class="bottomBtn">
      <div class="tubiao">
        <p @click="handleMark()">
          <img ref="mark" :data-status="ismark" :src="biaojiImg" alt />
          <!-- <span>标记</span> -->
        </p>
      </div>
      <div
        class="sheet-content tongji-showarea"
        @click="isSheetShow = !isSheetShow"
      >
        <div class="sheet-content-type">
          <div class="answered">
            <img class="sicon" src="../../../assets/images/trainTest/right_icon.png" />
            <span class="answered-num">{{ rightCount }}</span>
          </div>
          <div class="error">
            <img class="sicon" src="../../../assets/images/trainTest/error_icon.png" />
            <span class="answered-num">{{ errorCount }}</span>
          </div>
          <div class="unanswered">
            <img class="sicon" src="../../../assets/images/trainTest/unanswered_icon.png" />
            <span class="answered-num">{{ emptyCount }}</span>
          </div>
        </div>
      </div>
      <div class="btn">
        <van-button
          v-if="!justWatch"
          plain
          round
          type="info"
          class="commit"
          @click="commitPaper"
          >交卷</van-button
        >
      </div>
    </div>
    <!-- 答题卡 -->
    <van-action-sheet
      v-model="isSheetShow"
      title="答题卡"
      :close-on-click-action="true"
    >
      <span class="examTotal"> /共{{ examTotal }}题</span>
      <div class="sheet-content">
        <div class="sheet-content-type">
          <div class="answered">
            <img class="sicon" src="../../../assets/images/trainTest/right_icon.png" />
            正确
            <span class="answered-num">{{ rightCount }}</span>
          </div>
          <div class="error">
            <img class="sicon" src="../../../assets/images/trainTest/error_icon.png" />
            错误
            <span class="answered-num">{{ errorCount }}</span>
          </div>
          <div class="unanswered">
            <img class="sicon" src="../../../assets/images/trainTest/unanswered_icon.png" />
            未答
            <span class="answered-num">{{ emptyCount }}</span>
          </div>
        </div>
      </div>
      <div class="sheet-item" v-for="(val, key) in answerCardData" :key="key">
        <template v-if="val.vallist.length > 0">
          <p class="sheet-title">
            {{ filterType(key) }}题（共{{ val.vallist.length }}道）
          </p>
          <div class="sheet-num">
            <span
              @click="toThisOne(val.sindex + index)"
              :class="setColor(item)"
              v-for="(item, index) in val.vallist"
              :key="index"
            >
              {{ val.sindex + index + 1 }}
              <img
                v-if="item.mark"
                class="biaojiTopic"
                src="../../../assets/images/trainTest/biaoji_flag.png"
                alat
              />
            </span>
          </div>
        </template>
      </div>
    </van-action-sheet>
    <!-- 查看练习题类设置选择 -->
    <van-action-sheet
      class="seeSwitch"
      v-model="isWatchSettingShow"
      :actions="watchSettingActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="isWatchSettingShow = false"
      @select="watchSettingSelect"
    />
    <!-- 交卷弹框提醒 -->
    <van-dialog
      class="testdialog"
      v-model="commitPaperConfirmShow"
      title
      :show-confirm-button="false"
    >
      <img class="allowImg" src="../../../assets/images/trainTest/jinggao@2x.png" alt />
      <h2 class="allowH2">提示</h2>
      <p v-if="emptyCount > 0" class="allowP">
        你还有
        <span>{{ emptyCount }} </span>道题目未作答，确认交卷？
      </p>
      <p v-else class="allowP">
        是否确认提交？
      </p>
      <van-button
        class="allowBtn1 allowBtn"
        round
        type="info"
        plain
        @click="commitPaperConfirmShow = false"
        >继续答题</van-button
      >
      <van-button
        class="allowBtn2 allowBtn"
        round
        type="info"
        plain
        @click="allCommit"
        >提交</van-button
      >
    </van-dialog>
  </div>
</template>

<script>
import testMixin from "../../../utils/testMixin.js";
import { formatTime } from "../../exam/libs/timeformate.js";
export default {
  name: "testTrain",
  data() {
    return {
      startX: 0, // 触摸起始x
      startY: 0, // 触摸起始y
      endX: 0, // 触摸结束x
      endY: 0, // 触摸结束y
      canMove: true, // 是否可以继续滑动
      //
      ismark: 0,
      testtext: "练习",
      justWatch: false,
      isSheetShow: false,
      isWatchSettingShow: false, //练习查看设置
      watchSettingActions: [
        { name: "查看全部题目" },
        { name: "只看错题和未答题" }
      ],
      watchSetChoosedIndex: 0,
      questionsList: [],
      paperInfoAllQuestions: [],
      examTotal: 0,
      examType: ["单选", "多选", "判断", "高阶"],
      currentQuestion: {},
      currentRanking: 1,
      chooseNum: null,
      singleParams: {},
      allAnswer: [],
      moreanswer: [],
      moreChoose: null,
      rightCount: 0,
      errorCount: 0,
      emptyCount: 0,
      paperInfo: {},
      examParams: {
        userPracticeId: ""
      },
      biaojiImg: require("../../../assets/images/trainTest/biaoji_black.png"),
      answerCardData: {
        single: {
          sindex: 0,
          vallist: []
        },
        multiple: {
          sindex: 0,
          vallist: []
        },
        judge: {
          sindex: 0,
          vallist: []
        },
        highJudge: {
          sindex: 0,
          vallist: []
        }
      },
      commitPaperConfirmShow: false,
      historyTestEInfo: "", //练习中刷新时保存当时数据
      errorUnansweredIndexList: []
    };
  },
  mixins: [testMixin],
  watch: {
    questionsList: {
      handler: function(newV) {
        let rightArr = [],
          errorArr = [];
        rightArr = newV.filter(item => {
          return item.result === 1;
        });
        errorArr = newV.filter(item => {
          return item.result === 0 && item.reply;
        });
        this.rightCount = rightArr.length;
        this.errorCount = errorArr.length;
        this.emptyCount = this.examTotal - this.rightCount - this.errorCount;
      },
      deep: true
    },
    currentQuestion(val) {
      if (val) {
        this.ismark = val.mark ? val.mark : 0;
        this.biaojiImg =
          this.ismark === 0
            ? require("../../../assets/images/trainTest/biaoji_black.png")
            : require("../../../assets/images/trainTest/biaoji_light.png");
        if (this.justWatch || this.currentQuestion.reply) {
          if (val.type !== 2) {
            this.chooseNum = val.userAnswer;
            this.moreanswer = null;
          } else {
            this.moreanswer = val.userAnswer;
            this.chooseNum = null;
          }
        }
      }
    },
    ismark(val) {
      this.currentQuestion.mark = val;
    },
    isSheetShow(val) {
      if (val) {
        this.answerCardData = {
          single: {
            sindex: 0,
            vallist: []
          },
          multiple: {
            sindex: 0,
            vallist: []
          },
          judge: {
            sindex: 0,
            vallist: []
          },
          highJudge: {
            sindex: 0,
            vallist: []
          }
        };
        this.questionsList.forEach((item, index) => {
          if (item.type == 1) {
            this.answerCardData.single.vallist.push(item);
          } else if (item.type == 2) {
            this.answerCardData.multiple.vallist.push(item);
          } else if (item.type == 3) {
            this.answerCardData.judge.vallist.push(item);
          } else if (item.type == 4) {
            this.answerCardData.highJudge.vallist.push(item);
          }
        });
        this.answerCardData.single.sindex = 0;
        this.answerCardData.multiple.sindex = this.answerCardData.single.vallist.length;
        this.answerCardData.judge.sindex =
          this.answerCardData.single.vallist.length +
          this.answerCardData.multiple.vallist.length;
        this.answerCardData.highJudge.sindex =
          this.answerCardData.single.vallist.length +
          this.answerCardData.multiple.vallist.length +
          this.answerCardData.judge.vallist.length;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("pagehide", this.refreshParam);
    window.removeEventListener("beforeunload", this.refreshParam);
    window.removeEventListener("popstate", this.onTopic, false); //false阻止默认事件
    this.removeItem();
  },
  mounted() {
    this.pushState();
    this.examParams = { ...this.$route.query };
    if (this.$route.query.lastTopic === undefined) {
      this.findUserPaperInfo();
      this.justWatch = true;
    } else {
      //练习模式选择进来，定位到第几题
      this.findQuestForExam();
      window.addEventListener("beforeunload", this.refreshParam);
      window.addEventListener("pagehide", this.refreshParam);
      window.addEventListener(
        "offline",
        () => {
          this.$toast("网络异常");
        },
        false
      );
    }
  },
  methods: {
    removeItem() {
      sessionStorage.removeItem("historyTestEInfo");
    },
    filterType(val) {
      const types = {
        single: "单选",
        multiple: "多选",
        judge: "判断",
        highJudge: "高阶"
      };
      return types[val];
    },
    // 获取试题列表
    async findQuestForExam() {
      this.historyTestEInfo = JSON.parse(
        sessionStorage.getItem("historyTestEInfo")
      );
      if (
        this.historyTestEInfo &&
        this.historyTestEInfo.userPracticeId == this.examParams.userPracticeId
      ) {
        this.questionsList = this.historyTestEInfo.questionsList;
        this.examTotal = this.questionsList.length;
        this.currentQuestion = this.questionsList[0];
        if (
          this.historyTestEInfo.currentIndex &&
          this.historyTestEInfo.currentIndex >= 1 &&
          this.historyTestEInfo.currentIndex <= this.questionsList.length
        ) {
          this.toThisOne(this.historyTestEInfo.currentIndex - 1);
        }
      } else {
        const { data } = await this.$api.testTrain.findQuestForExam({
          userPracticeId: this.examParams.userPracticeId
        });
        this.questionsList = data.questions;
        this.examTotal = this.questionsList.length;
        this.currentQuestion = this.questionsList[0];
        if (
          this.examParams.lastTopic !== undefined &&
          this.examParams.lastTopic < this.examTotal
        ) {
          this.toThisOne(Number(this.examParams.lastTopic));
        } else if (
          this.examParams.lastTopic !== undefined &&
          this.examParams.lastTopic >= this.examTotal
        ) {
          this.toThisOne(this.examTotal - 1);
        }
      }
    },
    // 试卷详情回显
    async findUserPaperInfo() {
      const { data } = await this.$api.testTrain.findUserPaperInfo({
        userPracticeId: this.examParams.userPracticeId
      });
      this.paperInfoAllQuestions = data.examQuestionInfos;
      this.questionsList = JSON.parse(
        JSON.stringify(this.paperInfoAllQuestions)
      );
      this.examTotal = this.questionsList.length;
      this.currentQuestion = this.questionsList[0];
    },
    //滑动切换试题
    moveStart(e) {
      this.startX = e.targetTouches[0].pageX;
      this.startY = e.targetTouches[0].pageY;
    },
    onMove(e) {
      this.endX = e.targetTouches[0].pageX;
      this.endY = e.targetTouches[0].pageY;
      const dValueX = Math.abs(this.startX - this.endX);
      const dValueY = Math.abs(this.startY - this.endY);
      console.log('x方向差',dValueX);
      console.log('y方向差',dValueY);
      console.log('y/x',dValueY/dValueX)
      if (dValueX > dValueY && dValueY/dValueX<0.3) {//20度
        // 水平滑动长度大于纵向滑动长度，那么选择水平滑动，阻止浏览器默认左右滑动事件
        e.preventDefault();
        if (dValueX > 40 && this.startX > this.endX && this.canMove) {
          // 向左划,下一题
          this.canMove = false;
          this.changeTopic("next");
        } else if (dValueX > 40 && this.canMove) {
          this.canMove = false;
          this.changeTopic("prev");
        }
      } else {
        // 恢复默认事件
        window.event.returnValue = true;
      }
    },
    moveEnd(e) {
      this.canMove = true;
      this.startX = this.endX = 0;
      this.startY = this.endY = 0;
    },
    // 如果是单选、判断直接进入下一题
    activebtn(val) {
      if (this.justWatch || this.currentQuestion.reply) return false;
      let params = {
        answer: "",
        questionId: val.questionId,
        questionType: this.currentQuestion.type,
        mark: this.currentQuestion.mark ? 1 : 0
      };
      // 单选、判断
      if (this.currentQuestion.type !== 2) {
        this.chooseNum = null;
        this.questionsList[this.currentRanking - 1].reply = true;
        this.questionsList[this.currentRanking - 1].userAnswer =
          val.optionNumber;
        if (
          val.optionNumber ==
          this.questionsList[this.currentRanking - 1].rightAnswer
        ) {
          this.questionsList[this.currentRanking - 1].result = 1;
        } else {
          this.questionsList[this.currentRanking - 1].result = 0;
        }
        this.currentQuestion = this.questionsList[this.currentRanking - 1];
        this.$set(
          this.questionsList,
          this.currentRanking - 1,
          this.questionsList[this.currentRanking - 1]
        );
        params.answer = val.optionNumber;
        this.chooseNum = val.optionNumber;
        this.repetAnswer(params);
        this.singleCommit(params);
      } else {
        // 多选
        let isoption = this.moreanswer.indexOf(val.optionNumber);
        if (this.moreanswer.length === 0 || isoption === -1) {
          this.moreanswer.push(val.optionNumber);
          this.chooseNum = val.optionNumber;
        } else if (isoption !== -1) {
          this.chooseNum = null;
          this.moreanswer.splice(isoption, 1);
        }
      }
    },
    //单个多选题的答案提交操作
    async saveMultipleOptions() {
      if (this.moreanswer.length == 0) {
        this.$toast("请选择");
        return;
      }
      this.moreanswer = this.moreanswer.sort();
      const multipleAnswerStr = this.moreanswer.toString();
      this.questionsList[this.currentRanking - 1].reply = true;
      this.questionsList[
        this.currentRanking - 1
      ].userAnswer = multipleAnswerStr;
      if (
        multipleAnswerStr ==
        this.questionsList[this.currentRanking - 1].rightAnswer.toString()
      ) {
        this.questionsList[this.currentRanking - 1].result = 1;
      } else {
        this.questionsList[this.currentRanking - 1].result = 0;
      }
      this.currentQuestion = this.questionsList[this.currentRanking - 1];
      this.$set(
        this.questionsList,
        this.currentRanking - 1,
        this.questionsList[this.currentRanking - 1]
      );
      let params = {
        answer: "",
        questionId: this.currentQuestion.questionId,
        questionType: this.currentQuestion.type,
        mark: this.currentQuestion.mark ? 1 : 0
      };
      params.answer = multipleAnswerStr;
      this.moreChoose = { ...params };
      this.repetAnswer(this.moreChoose);
      await this.singleCommit(params);
      this.moreChoose = null;
    },

    // 返回上题
    onTopic() {
      this.$router.push({
        path: "/testDetail",
        query: {
          businessId: this.examParams.businessId,
          businessType: this.examParams.businessType,
          practiceId: this.examParams.practiceId,
          courseId: this.examParams.courseId,
          trainId: this.examParams.trainId,
          taskType: this.examParams.taskType,
          backType: this.examParams.backType
        }
      });
      // this.justWatch
      //   ? this.$router.push({
      //       path: "/testDetail",
      //       query: {
      //         businessId: this.examParams.businessId,
      //         businessType: this.examParams.businessType,
      //         practiceId: this.examParams.practiceId
      //       }
      //     })
      //   : this.commitPaper();
    },
    // 标记按钮
    handleMark() {
      let status = this.$refs.mark.dataset.status;
      this.ismark = +status === 0 ? 1 : 0;
      this.questionsList[this.currentRanking - 1].mark = this.ismark;
      this.biaojiImg =
        this.ismark === 0
          ? require("../../../assets/images/trainTest/biaoji_black.png")
          : require("../../../assets/images/trainTest/biaoji_light.png");
      let params = {
        answer: this.currentQuestion.userAnswer || "",
        mark: this.currentQuestion.mark ? 1 : 0,
        questionId: this.currentQuestion.questionId,
        questionType: this.currentQuestion.type
      };
      this.repetAnswer(params);
      this.$api.testTrain
        .markQuestion({
          businessId: this.examParams.businessId, //培训任务ID
          businessType: this.examParams.businessType, //类型(2:培训任务)
          mark: this.ismark, //(0:取消标记;1:标记)
          practiceId: this.examParams.practiceId,
          questionId: this.currentQuestion.questionId
        })
        .then(res => {});
    },
    //刷新页面，保存已做题到本地存储
    refreshParam() {
      this.pushState();
      window.history.pushState(null, null, "#");
      this.setHistory("refresh");
    },
    setHistory(val) {
      let historyTestEInfo = {
        questionsList: this.questionsList,
        currentIndex: this.currentRanking,
        allAnswer: this.allAnswer,
        userPracticeId: this.examParams.userPracticeId
      };
      val ? (historyTestEInfo.status = val) : "";
      sessionStorage.setItem(
        "historyTestEInfo",
        JSON.stringify(historyTestEInfo)
      );
    },
    pushState() {
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新
        window.addEventListener("popstate", this.onTopic, false); //false阻止默认事件
      }
    },
    //整体提交试卷答案
    commitPaper(tag) {
      this.pushState();
      if (this.moreChoose) {
        this.repetAnswer(this.moreChoose);
      }
      this.commitPaperConfirmShow = true;
    },
    // 全部题目提交
    async allCommit() {
      this.singleParams = {
        // answerList: this.allAnswer,
        answerList: [],
        commitTime: formatTime(new Date()),
        practiceId: this.examParams.userPracticeId
      };
      let data = this.singleParams;
      let {
        courseId,
        trainId,
        taskType,
        backType,
        practiceId
      } = this.$route.query;
      await this.$api.testTrain.commitAllPaper(data);
      this.$router.push({
        path: "/testResultsTrain",
        query: {
          id: this.examParams.userPracticeId,
          courseId,
          businessId: this.examParams.businessId,
          businessType: this.examParams.businessType,
          trainId,
          taskType,
          backType,
          practiceId,
          backPath: this.$route.query.backPath,
          goodsId:this.$route.query.goodsId,
          goodsKind:this.$route.query.goodsKind,
        }
      });
    },

    //查看练习题类-设置展示
    showWatchSettingChoose() {
      this.isWatchSettingShow = true;
      this.watchSettingActions.map((item, i) => {
        const color = this.watchSetChoosedIndex == i ? "#415FF6" : "#323233";
        this.$set(this.watchSettingActions[i], "color", color);
      });
    },
    //查看练习题类-设置选择
    watchSettingSelect(action, index) {
      if (index == 1) {
        this.errorUnansweredIndexList = [];
        this.paperInfoAllQuestions.map((item, qIndex) => {
          if (!(item.result && item.reply)) {
            this.errorUnansweredIndexList.push(qIndex);
          }
        });
        //无错题好无答题提示
        if (this.errorUnansweredIndexList.length == 0) {
          this.$toast("全部作答正确，无答错、未答");
          return;
        }
        this.currentRanking = this.errorUnansweredIndexList[0] + 1;
        this.currentQuestion = this.questionsList[
          this.errorUnansweredIndexList[0]
        ];
      } else {
        this.currentRanking = 1;
        this.currentQuestion = this.questionsList[0];
      }
      this.watchSetChoosedIndex = index;
    }
  }
};
</script>

<style scoped lang="less">
@import "../asset/css/testpage.less";
</style>
<style lang="less">
.failTy {
  background-color: rgba(236, 99, 94, 0.9);
}
.van-toast {
  height: 25px !important;
  border-radius: 20px !important;
  line-height: 40px !important;
  font-size: 14px !important;
}
@import "../asset/css/testpage1.less";
</style>
